export enum ChannelType {
  ATTENDEE_MESSAGING = 'attendee-messaging',
  GROUP_MESSAGING = 'group-messaging'
}

export enum MessagingFactOrigin {
  AttendeeList = 1,
  Community,
  Connections
}
